import { render } from "./BaseBtn.vue?vue&type=template&id=322b3560&scoped=true&lang=pug"
import script from "./BaseBtn.vue?vue&type=script&lang=js"
export * from "./BaseBtn.vue?vue&type=script&lang=js"

import "./BaseBtn.vue?vue&type=style&index=0&id=322b3560&scoped=true&lang=scss"
import "./BaseBtn.vue?vue&type=style&index=1&id=322b3560&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322b3560"]])

export default __exports__